import { useState } from 'react';
import Switch from '@/srp/Switch';
import { BudgetContextProvider } from './BudgetContext';
import BudgetFinance from './BudgetFinance';
import BudgetPrice from './BudgetPrice';

type Mode = 'finance' | 'price';

type Option = {
  value: Mode;
  display: string;
};

const options: Option[] = [
  { value: 'finance', display: 'Finance' },
  { value: 'price', display: 'Price' }
];

type OwnProps = {
  isShowing: boolean;
};

export default function Budget({ isShowing }: OwnProps) {
  const [budgetMode, setBudgetMode] = useState<Mode>('finance');

  return (
    <div className="gap-32 grid">
      <BudgetContextProvider>
        <Switch
          data-analytics-id="payment-price-switch"
          options={options}
          onUpdate={option =>
            setBudgetMode(option.value === 'finance' ? 'finance' : 'price')
          }
        />
        {budgetMode === 'finance' ? (
          <BudgetFinance isShowing={isShowing} />
        ) : (
          <BudgetPrice isShowing={isShowing} />
        )}
      </BudgetContextProvider>
    </div>
  );
}
